import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';
import {
	defaultTQC5020_R01DetailDto , TQC5020_R01DetailDto ,
	TQC5020_R01HeaderDto,
} from './Dto_TQC5020_R01';

export interface TQC5020_R01Filter {
	itemGroup: string;
	itemCd: string;
	itemNm: string;
}

export const defaultTQC5020_R01Filter: TQC5020_R01Filter = {
	itemGroup: '', itemCd: '', itemNm: '',
};

export interface Store_TQC5020_R01 {
	TQC5020_R01Filter: TQC5020_R01Filter;
	setTQC5020_R01Filter: (filter: Partial<TQC5020_R01Filter>) => void;

	TQC5020_R01HeaderList: TQC5020_R01HeaderDto[];
	setTQC5020_R01HeaderList: (list: TQC5020_R01HeaderDto[]) => void;

	selectedTQC5020_R01Header: TQC5020_R01HeaderDto | undefined;
	setSelectedTQC5020_R01Header: (item: TQC5020_R01HeaderDto | undefined) => void;

	TQC5020_R01HeaderColumnState: ColumnState[] | null;
	setTQC5020_R01HeaderColumnState: (state: ColumnState[] | null) => void;

	TQC5020_R01DetailList: TQC5020_R01DetailDto[];
	setTQC5020_R01DetailListList: (list: TQC5020_R01DetailDto[]) => void;
	updateTQC5020_R01DetailListList: (valueIndex: number, data: TQC5020_R01DetailDto) => void;

	originalTQC5020_R01DetailListList: TQC5020_R01DetailDto[];
	setOriginalTQC5020_R01DetailListList: (list: TQC5020_R01DetailDto[]) => void;

	TQC5020_R01DetailListColumnState: ColumnState[] | null;
	setTQC5020_R01DetailListColumnState: (state: ColumnState[] | null) => void;
	specScrollTop: number | null;
	setSpecScrollTop: (top: number | null) => void;

	inspTypeFilter: string;
	setInspTypeFilter: (inspType: string) => void;

	isNewItemModalOpen: boolean;
	setIsNewItemModalOpen: (open: boolean) => void;

	initData: () => void;
}

export const useTQC5020_R01Store = create<Store_TQC5020_R01>((set) => ({
	TQC5020_R01Filter: defaultTQC5020_R01Filter,
	setTQC5020_R01Filter: (update) => set((state) => ({ TQC5020_R01Filter: { ...state.TQC5020_R01Filter, ...update } })),

	TQC5020_R01HeaderList: [],
	setTQC5020_R01HeaderList: (itemList) => set({ TQC5020_R01HeaderList: itemList }),

	selectedTQC5020_R01Header: undefined,
	setSelectedTQC5020_R01Header: (selectedItem) => set({ selectedTQC5020_R01Header: selectedItem }),

	TQC5020_R01HeaderColumnState: null,
	setTQC5020_R01HeaderColumnState: (itemColumnState) => set({ TQC5020_R01HeaderColumnState: itemColumnState }),

	TQC5020_R01DetailList: [],
	setTQC5020_R01DetailListList: (list) => {
		const normalized = (list ?? []).map((item, idx) => ({
			...defaultTQC5020_R01DetailDto, ...item,
			valueIndex: idx + 1, orderIndex: idx + 1,
		}));
		set({ TQC5020_R01DetailList: normalized, originalTQC5020_R01DetailListList: normalized });
	},
	updateTQC5020_R01DetailListList: (valueIndex, data) => set((state) => ({
		TQC5020_R01DetailList: state.TQC5020_R01DetailList.map((item) => (item.valueIndex === valueIndex ? data : item)),
	})),

	originalTQC5020_R01DetailListList: [],
	setOriginalTQC5020_R01DetailListList: (originalSpecList) => set({ originalTQC5020_R01DetailListList: originalSpecList }),

	TQC5020_R01DetailListColumnState: null,
	setTQC5020_R01DetailListColumnState: (specColumnState) => set({ TQC5020_R01DetailListColumnState: specColumnState }),
	specScrollTop: null,
	setSpecScrollTop: (specScrollTop) => set({ specScrollTop }),

	inspTypeFilter: '',
	setInspTypeFilter: (inspTypeFilter) => set({ inspTypeFilter }),

	isNewItemModalOpen: false,
	setIsNewItemModalOpen: (isNewItemModalOpen) => set({ isNewItemModalOpen }),

	initData: () => set({
		TQC5020_R01Filter: defaultTQC5020_R01Filter,
		TQC5020_R01HeaderList: [], selectedTQC5020_R01Header: undefined,
		TQC5020_R01DetailList: [], originalTQC5020_R01DetailListList: [],
		inspTypeFilter: '',
		isNewItemModalOpen: false,
	}),
}));
